export { default } from "ember-stereo/helpers/seek-sound";
